import _ from 'lodash';
class ConfigurefacebookController {
  constructor(User, usSpinnerService) {
    "ngInject";
    this.name = 'configurefacebook';
    this.User = User;
    this.usSpinnerService = usSpinnerService;
    this.showSpinner = true;
  }

  $onInit() {

    this
      .User
      .getFacebookPages()
      .then((response) => {
        this.showSpinner = false;
        this.pages = response.data.pages.data;
        this.User.getFacebookSettings()
          .$loaded()
          .then((facebookSetting) => {
            if (facebookSetting.pageId) {
              this.selectedPage = _.find(this.pages, {
                id: facebookSetting.pageId
              });
              console.log('selectedPage', this.selectedPage);
            }
          });
      })
      .catch((err) => {
        this.showSpinner = false;
        console.log(err);
      });
  }

  savePages() {
    this.loading = true;
    this.User.saveFacebookPage({
        pageId: this.selectedPage.id,
        pageAccessToken: this.selectedPage.access_token
      }).then(() => {
        this.loading = false;
        this.dismissModal();
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      })
  }

  dismissModal() {
    this.dismiss({
      $value: 'cancel'
    });
  }
}

export default ConfigurefacebookController;



// WEBPACK FOOTER //
// ./client/app/components/home/modals/configurefacebook/configurefacebook.controller.js